import { ComponentProps } from 'react';
import { Slider } from '@/_shared/components/Slider';
import { Cards } from '../Cards';

type Props = {
  type?: 'video' | 'quiz' | 'document' | 'all';
  halfHeightLayout?: boolean;
  slideToShow?: ComponentProps<typeof Slider.SliderBottomRightArrow>['slideToShow'];
};

export const ContentsSkeleton = ({ halfHeightLayout, type = 'all', slideToShow }: Props) => {
  if (type === 'video') {
    return (
      <Slider.SliderBottomRightArrow slideToShow={slideToShow}>
        <Cards.Video loading />
        <Cards.Video loading />
        <Cards.Video loading />
      </Slider.SliderBottomRightArrow>
    );
  }
  if (type === 'quiz') {
    return (
      <Slider.SliderBottomRightArrow slideToShow={slideToShow}>
        <Cards.Quiz halfHeightLayout={halfHeightLayout} loading />
        <Cards.Quiz halfHeightLayout={halfHeightLayout} loading />
      </Slider.SliderBottomRightArrow>
    );
  }
  if (type === 'document') {
    return (
      <Slider.SliderBottomRightArrow slideToShow={slideToShow}>
        <Cards.Document loading />
        <Cards.Document loading />
        <Cards.Document loading />
      </Slider.SliderBottomRightArrow>
    );
  }

  return (
    <Slider.SliderBottomRightArrow slideToShow={slideToShow}>
      <Cards.Video loading />
      <Cards.Quiz loading />
      <Cards.Document loading />
    </Slider.SliderBottomRightArrow>
  );
};
